export enum FileTypeEnum {
    IMG = 'img',
    WORD = 'word',
    EXCEL = 'excel',
    PPT = 'ppt',
    PDF = 'pdf',
    ZIP = 'zip',
}
